import { useContext } from "react";
import { toast } from "react-toastify";

import {
  CarrierActivitiesContext,
  getDefaultCarrierActivities,
} from "context/CarrierActivitiesContext";

export const useCarrierActivities = () => {
  const carrierActivities = useContext(CarrierActivitiesContext);

  if (!carrierActivities) {
    toast.error("CarrierActivitiesContext is not available");

    return getDefaultCarrierActivities();
  }

  return carrierActivities;
};
